import { Component, OnInit, Output } from '@angular/core';
import { ApiPartnerService } from '@app/api/api-partner.service';
import { ChartType, ChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import { ExcelServicesService } from '@app/_services/excel-service.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-stokstb',
  templateUrl: './stokstb.component.html',
  styleUrls: ['./stokstb.component.css']
})
export class StokstbComponent implements OnInit {

  STBList: any = {};
  excel=[];
  table_load = false;
  table_data = false;
  first_index : number;
  last_index: number;
  total_count: number;
  querySearch = false;
  queryParams = '';
  msearch : string;
  currentParams = {};
  paging : any = {};
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  searchQueryParams = '';
  
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'right',
    },
    maintainAspectRatio: false
  };
  public pieChartLabels: Label[] = ['Active', 'New', 'Broken'];
  public pieChartData: SingleDataSet = [300, 500, 100];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];

  constructor(
    public partnerService: ApiPartnerService,
    private excelService:ExcelServicesService,
    private route: ActivatedRoute) {
      this.partnerService.GetStb().subscribe(data => {
        // console.log(data);
        data.data.forEach(row => {
          // console.log(row);
          this.excel.push(row);
        });
      });
    monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();
   }

  ngOnInit() {
    this.route.queryParams
      // .filter(params => params.order)
      .subscribe(params => {
        // console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if (params.search != '' && params.search != undefined ){
          console.log('search');
          console.log(params.search);
         this.msearch = params.search; 
         this.querySearch = true;
        

         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         this.loadSTB(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          // console.log(this.queryParams);
          // console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadSTB(this.queryParams);
        }
      });
  }

  queryStr(options){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  loadSTB(params) {
    this.table_load = true;
    return this.partnerService.GetListStb(params).subscribe((output: any) => {
      this.STBList = output;

      this.table_load = false
      this.table_data = true

      this.paging = this.STBList.pagex;
      this.page_self = this.STBList.pagex.self;
      this.page_next = this.STBList.pagex.next;
      this.page_prev = this.STBList.pagex.prev;
      this.meta = this.STBList.meta;
      this.total_count = this.meta['totalCount'];
      let self = this.page_self['page'];
      if ( self * this.meta['perPage'] < this.meta['totalCount']){
        this.last_index = (self * this.meta['perPage']);
      }else{
        this.last_index = this.meta['totalCount'];
      }
      
      this.first_index = ((self-1)*this.meta['perPage'])+1;

      // console.log(this.paging);
      //this.paging_link = this.STBList.paging.links;
    })
  }

  search()
  {
    this.querySearch = true;
    this.searchQueryParams = this.queryParams+'&search='+this.msearch;
    this.loadSTB(this.searchQueryParams);
  }

  exportAsXLSX():void {
    this.excelService.exportAsExcelFile(this.excel, 'Stok STB');
  }

}
